import React from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';

function ConfirmVaultMoveDialog({ app, pinned, onConfirm, onClose }) {
  const { run, saving, error } = useDialogMutation();

  return (
    <Dialog title="Save for later?" onClose={onClose} locked={saving}>
      <p className="dialog-text">
        This moves {app.name} out of its group.
        {pinned ? ' Its Quick Launch pin will also be removed.' : ''}
      </p>
      {error && <p className="dialog-error" role="alert">{error}</p>}
      <div className="dialog-actions">
        <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={saving}
          onClick={() => run(() => onConfirm(app.id), onClose)}
        >
          {saving ? 'Saving…' : 'Save for later'}
        </button>
      </div>
    </Dialog>
  );
}

export default ConfirmVaultMoveDialog;